export enum FeedbackEvent {
	OpenRequest = 'init-request-feedback',
	OpenUnsolicited = 'init-unsolicited-feedback',
	Created = 'feedback-created',
	UnsolicitedCreated = 'unsolicited-feedback-created',
	MessageChanged = 'feedback-message-changed',
	UnsolicitedMessageChanged = 'unsolicited-feedback-message-created',
}
